import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { SolidifierShot } from "../projectiles/solidifierShot";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";

export class Solidifier extends Weapon {
	static key = "Solidifier";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_GREEN;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_SOLIDIFIER));
		const spawnPos = this.owner.xy.add(directionDelta(direction));
		const shot = new SolidifierShot(spawnPos, direction);
		this.shotProjectile(board, shot);
	}

	static deserialize(data: any, owner: Player): Solidifier {
		const gun = new Solidifier(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
